import React from 'react';
import { Skeleton } from '@lion-design/core';
import cN from 'classnames';
import styles from './styles.module.scss';

interface SkeletonsProps {
    isMobile: boolean;
}
const Skeletons = (props: SkeletonsProps) => {
    const { isMobile } = props;

    return (
        <div className={cN(styles.skeleton_wrap, styles.skeleton_rounded)}>
            <Skeleton
                length={isMobile ? '33.33%' : '180px'}
                className={cN(styles.skeleton_img, styles.skeleton_rounded)}
            />
            <div className={styles.skeleton_content}>
                <div className={styles.skeleton_row}>
                    <Skeleton
                        length={isMobile ? '17.1%' : '127px'}
                        className={cN(styles.skeleton_h18, styles.skeleton_rounded)}
                    />
                    <Skeleton
                        length={isMobile ? '18px' : '24px'}
                        className={cN(styles.skeleton_rounded)}
                    />
                </div>
                <div className={styles.skeleton_row}>
                    <Skeleton
                        length={isMobile ? '100%' : '574px'}
                        className={cN(styles.skeleton_h24, styles.skeleton_rounded)}
                    />
                </div>
                <div className={styles.skeleton_row}>
                    <Skeleton
                        length={isMobile ? '59.4%' : '440px'}
                        className={cN(styles.skeleton_h18, styles.skeleton_rounded)}
                    />
                    {isMobile ? null : (
                        <Skeleton
                            length="72px"
                            className={cN(styles.skeleton_h18, styles.skeleton_rounded)}
                        />
                    )}
                </div>
                <div className={styles.skeleton_row}>
                    <Skeleton
                        length={isMobile ? '35%' : '133px'}
                        className={cN(styles.skeleton_h24, styles.skeleton_rounded)}
                    />
                </div>
            </div>
        </div>
    );
};

export default Skeletons;
